/**
 * QRِ «اپ رو بگیر» — همان تصویرِ ثابتی که scripts/make-app-qr.mjs ساخته.
 *
 * چرا اصلاً QR: چون روی دسکتاپ هیچ‌کدام از دو فروشگاه به‌درد نمی‌خورد. کسی
 * که سایت را روی لپ‌تاپ باز کرده نمی‌تواند اپِ گوشی را نصب کند، و دکمه‌ی
 * «نصب کن» فقط او را به یک صفحه‌ی بی‌فایده می‌فرستد. QR آن فاصله را برمی‌دارد:
 * با گوشیِ خودش اسکن می‌کند و همان‌جا ادامه می‌دهد.
 *
 * و چرا QR به فروشگاه اشاره نمی‌کند بلکه به `/get` روی خودِ سایت: یک تصویرِ
 * ثابت نمی‌داند چه کسی اسکندش می‌کند. تصمیمِ «اندروید یا آیفون» باید روی
 * همان دستگاه گرفته شود — نگاه کن به core/lib/appStore.ts.
 *
 * ═══ چرا هیچ کتابخانه‌ای این‌جا نیست ═══
 *
 * محتوای این کد هیچ‌وقت عوض نمی‌شود، پس یک‌بار ساخته شده و به‌شکلِ یک مسیرِ
 * SVG چک‌این شده. یک گره، سه کیلوبایت، بدونِ هیچ وابستگیِ تازه‌ای در باندل.
 *
 * ═══ تنها رنگِ hardcodeی این اپ، و عمدی ═══
 *
 * قاعده‌ی apps/web این است که هیچ رنگی مستقیم نوشته نشود و همه از
 * `var(--…)` بیاید، تا تمِ تیره نشکند. این‌جا استثناست و باید بماند: QR یک
 * تصویرِ خواندنی برای دوربین است، نه یک عنصرِ رابط. سیاه روی سفید بیشترین
 * کنتراستِ ممکن است و حاشیه‌ی روشنش بخشی از استاندارد؛ اگر با تمِ تیره
 * برمی‌گشت، در حالتِ تیره اسکن نمی‌شد. پس رنگش با تم عوض **نمی‌شود**.
 */
import React from 'react';
import { QR_MODULES, QR_PATH } from './appQrData';

export function AppQr({ size = 148 }: { size?: number }) {
  return (
    <svg
      className="app-qr"
      width={size}
      height={size}
      viewBox={`-2 -2 ${QR_MODULES + 4} ${QR_MODULES + 4}`}
      role="img"
      aria-label="QR"
      shapeRendering="crispEdges">
      {/* حاشیه‌ی روشنِ دورِ کد بخشِ خودِ استانداردست، نه تزئین: بدونش
          دوربین لبه‌ی کد را پیدا نمی‌کند. `viewBox` دو خانه از هر طرف
          بازتر گرفته شده و این مستطیل پُرش می‌کند. */}
      <rect x={-2} y={-2} width={QR_MODULES + 4} height={QR_MODULES + 4} fill="#fff" />
      <path d={QR_PATH} fill="#000" />
    </svg>
  );
}
